import variables from '../../variables.module.scss';

const MuiSelect = {
  styleOverrides: {
    select: {
      borderRadius: '4px',
      marginTop: 1,
      paddingTop: 12,
      '&:focus': {
        backgroundColor: `${variables.selectHovEvents}`,
      },
      '&$filled': {
        backgroundColor: `${variables.selectHovEvents}`,
        borderRadius: '4px',
      },
      '&$disabled': {
        color: `${variables.disabledSelect}`,
      },
      '& .option-changed': {
        outline: 'none',
        borderColor: variables.optionChangedBorder,
        boxShadow: `0 0 10px ${variables.optionChangedBoxShadow}`,
      },
    },
    outlined: {
      paddingTop: 15,
      paddingBottom: 5,
    },
  },
};

export default MuiSelect;
